<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <div v-if="messageStatus" class="alert alert-success" role="alert">
            {{ messageStatus }}
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>Товары в пути</h2>
                    <router-link tag="a" :to="'/admin/way/add'" class="btn btn-info waves-effect m-t-15"
                                 style="margin: 15px 0">Добавить
                    </router-link>
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Код</th>
                            <th>Наименование</th>
                            <th>Тип</th>
                            <th>Цена (дилер)</th>
                            <th>Цена (оптовик)</th>
                            <th>ID категории</th>
                            <th>Опции</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                            <td>{{ item.id }}</td>
                            <td>{{ item.vendor_code }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.type }}</td>
                            <td>{{ item.price_dealer }}</td>
                            <td>{{ item.price_wholesale }}</td>
                            <td>{{ item.category_id }}</td>
                            <td style="position: relative">
                                <button class="btn btn-danger" @click="execWarning(item.id, index)">Удалить</button>
                                <router-link tag="button" class="btn btn-success" :to="{name: 'ProductsOnWayEdit', params: {id: item.id}}">Изменить</router-link>
                                <b-form-checkbox v-model="item.enable" name="check-button" style="position:absolute; right: 0.5rem; display: inline-block;" switch @change="enable(item.id, item.enable)"></b-form-checkbox>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const Swal = require('sweetalert2');

    export default {
        name: "ProductsOnWay",
        props: ['message'],
        data() {
            return {
                items: [],
                messageStatus: null,
                loading: false
            }
        },

        mounted() {
            this.messageStatus = this.message
            this.loading = true

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/ways')
                .then(response => {
                    this.items = response.data.products;

                    for(let i = 0; i < this.items.length; i++) {
                        this.items[i].enable = !!Number(this.items[i].enable);
                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
            })
        },

        methods: {

            execWarning(id, index){
                Swal.fire({
                    title: 'Вы точно хотите удалить товар?',
                    text: "После удаления вы не сможете восстановить его",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Отменить',
                    confirmButtonText: 'Удалить!'
                }).then((result) => {
                    if (result.value) {
                        this.destroy(id, index);
                    }
                })
            },

            enable(id, enable) {
                this.axios
                    .post(this.axios.defaults.baseURL + 'admin/ways/enable/' + id, {value: enable})
                    .then(response => {
                        if (response.data.message === 'success') {
                            if(response.data.product) {
                                this.messageStatus = 'Успешно включен';
                            } else {
                                this.messageStatus = 'Успешно выключен';
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },

            destroy(id, index) {
                this.axios
                    .delete(this.axios.defaults.baseURL + 'admin/ways/' + id)
                    .then(response => {
                        if (response.data.message === 'success') {
                            this.items.splice(index, 1);
                            this.messageStatus = 'Успешно удален';
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/admin/way/index.vue